import { CommonActions, useCommonSelector } from '@wajeez-web/stores/common';
import AccessDenied from '../errorsPages/AccessDenied';
import ServerDown from '../errorsPages/serverDown';
import Alert from './Alert';
import React, { useEffect, useRef } from 'react';
// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface AsyncComponentProps {
  // Component: React.ComponentType;
}

const AsyncComponent: React.FC<
  React.PropsWithChildren<AsyncComponentProps>
> = ({ children }) => {
  const error = useCommonSelector((state) => state.common.error);
  const alert = useCommonSelector((state) => state.common.alert);
  //   const { refresh } = useAppSelector((store) => store.lists);
  const loading = useCommonSelector((state) => state.common.loading);
  useEffect(() => {
    CommonActions.setError({ show: false, type: null });
    // CommonActions.hideLoading();

    return () => {
      CommonActions.setError({ show: false, type: null });
      CommonActions.clearAlert();
      // CommonActions.hideLoading();
    };
  }, []);

  return error.show ? (
    error.type === 500 ? (
      <ServerDown />
    ) : (
      <AccessDenied />
    )
  ) : (
    <div className=" relative  ">
      {/* {refresh && (
              <div className="linear-activity w-full ">
                <div className="indeterminate"></div>
              </div>
            )} */}
      {alert.for === 'page' && <Alert />}
      {children}
    </div>
  );
};

export default AsyncComponent;
